var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "item pb-3 mb-5 border-bottom",
      attrs: { id: "job--" + _vm.item.id }
    },
    [
      _c(
        "transition",
        { attrs: { mode: "out-in", name: "slide" } },
        [
          !_vm.isEdit
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 mb-3" }, [
                  _c("div", { staticClass: "row mb-3" }, [
                    _c("h2", { staticClass: "col-12 col-md-9" }, [
                      _vm._v(_vm._s(_vm.element.headline))
                    ]),
                    _vm._v(" "),
                    _c("h2", { staticClass: "col-12 col-md-3 text-md-right" }, [
                      _c(
                        "span",
                        {
                          staticClass: "badge",
                          class: _vm.element.active
                            ? "badge-success"
                            : "badge-danger"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.element.active ? "Aktiv" : "Inaktiv")
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.showMore
                    ? _c("div", { attrs: { id: "job-item-" + _vm.item.id } }, [
                        _c("div", { staticClass: "row mb-3" }, [
                          _c("div", { staticClass: "col-12 col-md-6" }, [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "h4",
                                { staticClass: "col-12 border-bottom" },
                                [_vm._v("Wichtige Job Daten")]
                              ),
                              _vm._v(" "),
                              _vm.element.state
                                ? _c("p", { staticClass: "col-12" }, [
                                    _c("b", [
                                      _c("i", {
                                        staticClass: "fad fa-map-pin"
                                      }),
                                      _vm._v(" Bundesland")
                                    ]),
                                    _vm._v(
                                      ":\n                                    " +
                                        _vm._s(_vm.element.state.name)
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.element.type
                                ? _c("p", { staticClass: "col-12" }, [
                                    _c("b", [
                                      _c("i", {
                                        staticClass: "fad fa-user-md"
                                      }),
                                      _vm._v(" Anstellungsart")
                                    ]),
                                    _vm._v(": " + _vm._s(_vm.element.type.name))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.element.hours
                                ? _c("p", { staticClass: "col-12" }, [
                                    _c("b", [
                                      _c("i", { staticClass: "fad fa-clock" }),
                                      _vm._v(" Wochenstunden")
                                    ]),
                                    _vm._v(
                                      ":\n                                    " +
                                        _vm._s(_vm.element.hours) +
                                        "\n                                "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.element.salary
                                ? _c("p", { staticClass: "col-12" }, [
                                    _c("b", [
                                      _c("i", {
                                        staticClass: "fad fa-euro-sign"
                                      }),
                                      _vm._v(" Monatsbruttogehalt")
                                    ]),
                                    _vm._v(
                                      ":\n                                    " +
                                        _vm._s(_vm.element.salary)
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-md-6" }, [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "h4",
                                { staticClass: "col-12 border-bottom" },
                                [_vm._v("Kontakt Informationen")]
                              ),
                              _vm._v(" "),
                              _vm.element.merchant.contact[0].name
                                ? _c("p", { staticClass: "col-12" }, [
                                    _c("b", [
                                      _c("i", { staticClass: "fad fa-user" }),
                                      _vm._v(" Arbeitgeber")
                                    ]),
                                    _vm._v(
                                      ":\n                                    " +
                                        _vm._s(
                                          _vm.element.merchant.contact[0].name
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.element.merchant.contact[0].fax
                                ? _c("p", { staticClass: "col-12" }, [
                                    _c("b", [
                                      _c("i", { staticClass: "fad fa-fax" }),
                                      _vm._v(" Fax")
                                    ]),
                                    _vm._v(
                                      ": " +
                                        _vm._s(
                                          _vm.element.merchant.contact[0].fax
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.element.merchant.contact[0].phone
                                ? _c("p", { staticClass: "col-12" }, [
                                    _c("b", [
                                      _c("i", { staticClass: "fad fa-phone" }),
                                      _vm._v(" Tel.")
                                    ]),
                                    _vm._v(
                                      ":\n                                    " +
                                        _vm._s(
                                          _vm.element.merchant.contact[0].phone
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.element.merchant.contact[0].email
                                ? _c("p", { staticClass: "col-12" }, [
                                    _c("b", [
                                      _c("i", {
                                        staticClass: "fad fa-envelope"
                                      }),
                                      _vm._v(" Email")
                                    ]),
                                    _vm._v(
                                      ":\n                                    " +
                                        _vm._s(
                                          _vm.element.merchant.contact[0].email
                                        )
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("h4", { staticClass: "col-12 border-bottom" }, [
                            _vm._v("Stellenbeschreibung")
                          ]),
                          _vm._v(" "),
                          _vm.element.description
                            ? _c("div", {
                                staticClass: "col-12",
                                domProps: {
                                  innerHTML: _vm._s(_vm.element.description)
                                }
                              })
                            : _vm._e()
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-3 mb-3" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-info mt-3",
                      on: {
                        click: function($event) {
                          _vm.showMore = !_vm.showMore
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.showMore ? "Weniger Anzeigen" : "Mehr Anzeigen"
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-4 my-3 d-flex flex-row justify-content-center"
                  },
                  [
                    _vm.element.media && _vm.element.media[0]
                      ? _c("span", [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-sm btn-success",
                              attrs: {
                                href: _vm.element.media[0].url,
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                "\n                        Herunterladen "
                              ),
                              _c("i", { staticClass: "fas fa-download" })
                            ]
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-5 mb-3" },
                  [
                    _c("buttons", {
                      attrs: { isLoading: _vm.isLoading },
                      on: {
                        delete: function($event) {
                          return _vm.deleteItem(_vm.item.id)
                        },
                        edit: function($event) {
                          _vm.isEdit = true
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("h3", [_vm._v("Bewerbungen")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "table-responsiv" }, [
                    _c("table", { staticClass: "table" }, [
                      _c("thead", [
                        _c("tr", [
                          _c("th", { attrs: { scope: "col" } }, [_vm._v("#")]),
                          _vm._v(" "),
                          _c("th", { attrs: { scope: "col" } }, [
                            _vm._v("Anhang")
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { scope: "col" } }, [
                            _vm._v("Name")
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { scope: "col" } }, [
                            _vm._v("Adresse")
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { scope: "col" } }, [
                            _vm._v("PLZ")
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { scope: "col" } }, [
                            _vm._v("Stadt")
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { scope: "col" } }, [
                            _vm._v("Land")
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { scope: "col" } }, [
                            _vm._v("Geburtsdatum")
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { scope: "col" } }, [
                            _vm._v("Telefonnummer")
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { scope: "col" } }, [
                            _vm._v("E-Mail")
                          ]),
                          _vm._v(" "),
                          _c("th", { attrs: { scope: "col" } }, [
                            _vm._v("Nachricht")
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.element.applications, function(
                          applicant,
                          index
                        ) {
                          return _c("tr", { staticClass: "application__row" }, [
                            _c("th", { attrs: { scope: "row" } }, [
                              _vm._v(_vm._s(index + 1))
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              applicant.media.length > 0
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "mb-0",
                                      attrs: {
                                        href: _vm.mediaPath(applicant),
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fad fa-file-download"
                                      })
                                    ]
                                  )
                                : _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(" - ")
                                  ])
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              applicant.name
                                ? _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(_vm._s(applicant.name))
                                  ])
                                : _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(" - ")
                                  ])
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              applicant.address
                                ? _c("p", { staticClass: "mb-0 address" }, [
                                    _vm._v(_vm._s(applicant.address))
                                  ])
                                : _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(" - ")
                                  ])
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              applicant.zip
                                ? _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(_vm._s(applicant.zip))
                                  ])
                                : _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(" - ")
                                  ])
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              applicant.city
                                ? _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(_vm._s(applicant.city))
                                  ])
                                : _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(" - ")
                                  ])
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              applicant.country
                                ? _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(_vm._s(applicant.country))
                                  ])
                                : _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(" - ")
                                  ])
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              applicant.birthdate
                                ? _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(_vm._s(applicant.birthdate))
                                  ])
                                : _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(" - ")
                                  ])
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              applicant.phone
                                ? _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(_vm._s(applicant.phone))
                                  ])
                                : _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(" - ")
                                  ])
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              applicant.email
                                ? _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(_vm._s(applicant.email))
                                  ])
                                : _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(" - ")
                                  ])
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              applicant.message
                                ? _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(_vm._s(applicant.message))
                                  ])
                                : _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(" - ")
                                  ])
                            ])
                          ])
                        }),
                        0
                      )
                    ])
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isEdit
            ? _c("buero-form", {
                attrs: {
                  elementValues: this.element,
                  schema: _vm.schema,
                  method: "patch",
                  url: "/api/merchant/jobs"
                },
                on: { cancel: _vm.cancelEdit, updateItem: _vm.updateItem }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }